module.exports = __webpack_public_path__ + "media/images/nb-446cece317316c578f9225f7c6dbe747.svg";